import { Component, type ComponentType, type ErrorInfo, type PropsWithChildren, type ReactNode } from 'react';

type ErrorBoundaryProps = {
    fallback?: ReactNode;
};

type ErrorBoundaryState = {
    hasError: boolean;
};

export class ErrorBoundary extends Component<PropsWithChildren<ErrorBoundaryProps>, ErrorBoundaryState> {
    constructor(props: PropsWithChildren<ErrorBoundaryProps>) {
        super(props);
        this.state = {
            hasError: false,
        };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    // TODO REIS-4403: proper error logging should be done here
    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error(error);
        console.error(errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback || null;
        }
        return this.props.children;
    }
}

export const withErrorBoundary = <P extends object>(TheComponent: ComponentType<P>) => {
    const Wrapped = (props: P) => (
        <ErrorBoundary>
            <TheComponent {...props} />
        </ErrorBoundary>
    );
    // Format for display in DevTools
    const name = TheComponent.displayName || TheComponent.name;
    Wrapped.displayName = name ? `WithErrorBoundary(${name})` : 'WithErrorBoundary';

    return Wrapped;
};
